import WrappedForm from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    WrappedForm
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    jobInfo: {
      required: true
    },
    isTemplate: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    companyIsELC: {
      type: Boolean,
      default: false
    },
    companyDataParams: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.editor',
      hasForm: true,
      hasChangedData: false,
      stepData: {}
    }
  },
  computed: {
    isNotEditableJobTemplate () {
      const template = this.jobInfo.job_template
      return template && template.job_property === '0'
    },
    isOverseasCompany () {
      return this.hasAnyPermission('COMPUTED_COMPANY_IS_OVERSEAS_COMPANY')
    },
    allowEmployeeApplyJob () {
      return this.hasAnyPermission(['COMPUTED_COMPANY_REFERRAL_ENABLED', 'PREMIUM_REFERRAL_EMPLOYEE_APPLY_INTERNAL_JOB'])
    },
    hasCreateJobPermission () {
      return this.hasAnyPermission('PERM_JOB_CREATE')
    },
    hasCreateJobFromTemplatePermission () {
      return this.hasAnyPermission('PERM_JOB_CREATE_FROM_TEMPLATE')
    },
    showATSId () {
      return this.hasAnyPermission({
        strict: false,
        any: [
          'PERM_EDIT_ANY_JOB',
          'COMPUTED_COMPANY_SHOW_JOB_ATS_ID'
        ]
      })
    },
    canCustomJobDetailInfo () {
      return this.hasAnyPermission(['PREMIUM_CUSTOM_JOB_DETAIL', 'PREMIUM_CUSTOM_JOB_DETAIL_JOB_LEVEL', 'PERM_CUSTOMIZE_JOB_DETAIL_PAGE'])
    },
    hasCustomJobDetailCompanyLevel () {
      return this.hasAnyPermission(['PREMIUM_CUSTOM_JOB_DETAIL', 'PREMIUM_CUSTOM_JOB_DETAIL_COMPANY_LEVEL', 'PERM_CUSTOMIZE_JOB_DETAIL_PAGE'])
    },
    canCustomAssessment () {
      return this.hasAnyPermission('COMPUTED_COMPANY_JOB_ASSESSMENT_CUSTOMIZED')
    },
    hasAssessmentPermission () {
      return this.hasAnyPermission('PREMIUM_ASSESSMENTS')
    },
    hasPrescreenSurveyPermission () {
      return this.hasAnyPermission(['PERM_CHATBOT_PRESCREEN_SURVEY_MANAGEMENT', 'PREMIUM_CHATBOT_PRESCREEN_SURVEY_MANAGEMENT'])
    },
    hasVideoQuestionPermission () {
      return this.hasAnyPermission('PREMIUM_UPLOAD_VIDEO')
    },
    hasAttachmentQuestionPermission () {
      return this.hasAnyPermission('PREMIUM_UPLOAD_PORTFOLIO')
    },
    hasCrmTagPermission () {
      return this.hasAnyPermission('PREMIUM_TAG_MANAGEMENT')
    },
    hasTagManagementPermission () {
      return this.hasAnyPermission('PERM_TAG_MANAGEMANT')
    },
    hasEditAnyJobPermission () {
      return this.hasAnyPermission('PERM_EDIT_ANY_JOB')
    },
    hasCloseJobPermission () {
      return this.hasAnyPermission('PERM_JOB_CLOSE')
    },
    hasReapplyPermission () {
      return this.hasAnyPermission('PREMIUM_RE_APPLY')
    },
    hasCustomFiledPermission () {
      return this.hasAnyPermission('PREMIUM_JOB_CUSTOM_FIELD')
    },
    hasSatisfactionSurveyPermission () {
      return this.hasAnyPermission('PREMIUM_SATISFACTION_SURVEY')
    },
    hasOpenQuestionTemplatePermission () {
      return this.hasAnyPermission('PERM_JOB_QUESTION_TEMPLATE')
    },
    hasSatisfactionSurveyHMPermission () {
      return this.hasAnyPermission('PREMIUM_SATISFACTION_SURVEY_HM')
    },
    hasSatisfactionSurveyCandidatePermission () {
      return this.hasAnyPermission('PREMIUM_SATISFACTION_SURVEY_CANDIDATE')
    },
    hasHMInterviewPermission () {
      return this.hasAnyPermission('PREMIUM_INTERVIEW_SCHEDULING')
    },
    hasHMRatingPermission () {
      return this.hasAnyPermission('PREMIUM_INVITE_HM_REVIEW')
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    async setStepDataToJobInfo () {

    },
    async getStepData () {

    },
    async resetForm () {
      this.stepData = await this.getStepData()
      await this.$nextTick()
      this.clearValidate()
      this.hasChangedData = false
    },
    async clearCustomValidate () {

    },
    async clearValidate () {
      if (this.hasForm) {
        let form = this.$refs.form
        if (!form) {
          await this.$nextTick()
          form = this.$refs.form
        }
        if (!form) {
          return
        }
        await form.clearValidate()
      }
      this.clearCustomValidate()
    },
    async customValidate () {
      return true
    },
    async validate () {
      let isValid = true
      if (this.hasForm) {
        isValid = await this.$refs.form.submit()
      }
      if (isValid) {
        isValid = await this.customValidate()
      }
      return Boolean(isValid)
    },
    async submit (ignoreError) {
      const isValid = await this.validate()
      if (ignoreError || isValid) {
        await this.setStepDataToJobInfo()
        this.hasChangedData = false
      }
      return isValid
    }
  },
  watch: {
    show: {
      immediate: true,
      handler () {
        if (this.show) {
          this.$nextTick(() => {
            this.$emit('reset', this.resetForm())
          })
        }
      }
    },
    stepData: {
      deep: true,
      handler () {
        this.hasChangedData = true
      }
    }
  }
}
